import { connect } from 'pwa-helpers';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { nothing } from 'lit-html';
import store from '../../store/store';
import { StoreState } from '../../store/store.interface';
import './alert';
import { BaseComponent } from '../../features/base-component/base-component';
import { MessageType } from './global-message.interface';
import { selectGlobalMessage } from './global-message';

/**
 * This component uses the alert component but ties it to a global message binding so
 * components on one part of the page can add an error message to the state and then a component
 * somewhere else on the page can display that error message.
 *
 * For example, to display a message with the id of "cart" do this:
 *
 * &lt;mhecomm-alert-global messageId="cart"></mhecomm-alert-global>
 *
 * Then, to update the "cart" error message, do this:
 *
 * store.dispatch(updateGlobalMessage({ id: 'cart', message: 'Hello, World!'}))
 *
 * The UI of the error message is controlled by the &lt;mhecomm-alert> component, not this component.
 */

@customElement('mhecomm-alert-global')
export class AlertGlobal extends connect(store)(BaseComponent) {
  @property()
  messageId = '';

  @state()
  private message = '';

  @state()
  private type = MessageType.none;

  @state()
  private dismissible = false;

  @state()
  private toggleAlert = true;

  renderComp() {
    return html`
      ${this.toggleAlert
        ? html`<mhecomm-alert
            message=${this.message}
            type=${this.type}
            ?dismissible=${this.dismissible}
            @alert-close=${() => (this.toggleAlert = false)}
          ></mhecomm-alert>`
        : nothing}
    `;
  }

  stateChanged(state: StoreState) {
    const messageData = selectGlobalMessage(state, this.messageId);
    this.message = messageData.message;
    this.type = messageData.type;

    if (this.message && this.type !== MessageType.none) {
      this.toggleAlert = true;
    } else {
      this.toggleAlert = false;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-alert-global': AlertGlobal;
  }
}
